import React from "react";
import { SourceTypes } from "@common/types/server-list-types";
import styles from "./edit-source-name-gateways-list.module.scss";
import {
  useEditSourceNameGatewaysListHook,
} from "./use-edit-source-name-gateways-list-hook";
import { GatewayWithSourceViewStateTypes } from "@common/types/gateways-list-types";
import { useI18N } from "@src/language/language-context";
import { IconButton } from "@src/components/atoms/buttons/icon-button/icon-button";
import renameIcon from "@src/assets/svg/rename-blue-icon.svg";
import saveIcon from "@src/assets/svg/save-right-blue-icon.svg";
import closeIcon from "@src/assets/svg/close-orange-icon.svg";

interface EditSourceNameGatewaysListPropTypes {
  gateway: GatewayWithSourceViewStateTypes;
  source: SourceTypes;
}

const cssClassName = "edit-source-name-gateways-list";

export const EditSourceNameGatewaysList = ({
  gateway,
  source,
}: EditSourceNameGatewaysListPropTypes) => {
  const {
    showInput,
    editSourceName,
    onKeyDownFunc,
    updateNewSourceName,
    saveSourceName,
    cancelSaveSourceName,
    newSourceName,
  } = useEditSourceNameGatewaysListHook(gateway, source);
  const i18n = useI18N();

  const texts = {
    save: i18n("modules.editSourceName.save"),
    edit: i18n("modules.editSourceName.edit"),
    cancel: i18n("modules.editSourceName.cancel"),
  };

  return (
    <>
      <span className={styles[cssClassName]}>
        {!showInput && (
          <span className={styles[`${cssClassName}__item-name-wrapper`]}>
            <span className={styles[`${cssClassName}__item-name`]}>
              {newSourceName || source.name}
            </span>
            <span className={styles[`${cssClassName}__edit-text-button`]}>
              <IconButton
                fun={(e) => editSourceName(e)}
                icon={renameIcon}
                tooltip={texts.edit}
                variant="edit-save-close-icon"
              />
            </span>
          </span>
        )}
        {showInput && (
          <>
            <span
              className={styles[`${cssClassName}__item-name-input-wrapper`]}
            >
              <input
                type="text"
                value={newSourceName}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onChange={(e) => {
                  updateNewSourceName(e, e.target.value);
                }}
                onKeyDown={(e) => {
                  onKeyDownFunc(e);
                }}
                className={styles[`${cssClassName}__item-name-input`]}
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus
              />
            </span>
            <div className={styles[`${cssClassName}__buttons-wrapper`]}>
              <span className={styles[`${cssClassName}__save-text-button`]}>
                <IconButton
                  fun={(e) => saveSourceName(e)}
                  icon={saveIcon}
                  tooltip={texts.save}
                  variant="edit-save-close-icon"
                />
              </span>
              <span className={styles[`${cssClassName}__cancel-text-button`]}>
                <IconButton
                  fun={(e) => cancelSaveSourceName(e)}
                  icon={closeIcon}
                  tooltip={texts.cancel}
                  variant="edit-save-close-icon"
                />
              </span>
            </div>
          </>
        )}
      </span>
    </>
  );
};
